import type { HelpFile } from '../../types/help'
import { AccessRequestsTestIds } from '../../../testids/AccessRequestsTestIds'

export const accessRequestsHelp: HelpFile = {
  docPage: '/docs/governance/access-requests',
  texts: {
    [AccessRequestsTestIds.accessRequestsList]: 'All access requests in the system — submitted directly or by a delegate on behalf of someone else.',
    [AccessRequestsTestIds.btnCreateRequest]: 'Open the access request wizard to pick a beneficiary, select access profiles, and submit for approval.',
    [AccessRequestsTestIds.colBeneficiary]: 'Identity that will receive the access if the request is approved.',
    [AccessRequestsTestIds.colRequester]: 'Identity that submitted the request — may differ from the beneficiary when a delegate acts on behalf of someone.',
    [AccessRequestsTestIds.colItems]: 'Access profiles and other items included in this request.',
    [AccessRequestsTestIds.colJustification]: 'Reason submitted with the request — visible to approvers when they decide.',
  },
}
